import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-98513590-2'
})

import {library} from "@fortawesome/fontawesome-svg-core";
import {faEnvelope, faUser, faUsers} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

library.add(faEnvelope, faUsers, faUser);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// document.title = 'SARP - Signup';


Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
